import { useLazyQuery } from '@apollo/client';

import { VOUCHER } from '../graphql/query/voucherQuery.graphql';

export const useVoucherQuery = () => {
  const [callQuery, { data }] = useLazyQuery(VOUCHER);

  const getVoucher = (code: string, eventId: string) =>
    callQuery({
      variables: {
        code,
        eventId,
      },
    });

  return { getVoucher, data };
};
